import React from "react";
import { Box, Skeleton } from "@mui/material";

const BannerPartialSkeleton: React.FC = () => {
    return (
        <Box
            component="section"
            sx={{
                width: "100%",
                position: "relative",
                overflow: "hidden",
                height: { xs: 150, sm: 200, md: 210 },
            }}
        >
            {/* Banner skeleton */}
            <Skeleton
                variant="rectangular"
                animation="wave"
                sx={{
                    width: "100%",
                    height: "100%",
                }}
            />
        </Box>
    );
};

export default BannerPartialSkeleton;
